import { useRef } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { addDaysToDate, parseAsLocalDate } from "../../../utils";
import Toran from "../art/Garland";
import { MarigoldDivider } from "../art/Icons";
import { Petals } from "../art/Ambience";
import ColorBlast from "../art/ColorBlast";
import Reveal from "../Reveal";
import useLive from "../useLive";
// Rajasthani folk musicians on a rug, with umbrellas, peacocks and flowering bushes
// (rajasthani-folk-festival.png, its black backdrop keyed out, cropped and compressed).
import folkFestival from "../../../images/rang-utsav/rajasthani-folk-festival.webp";

/**
 * The last page: the closing message and the date above the painted folk musicians,
 * with clouds of Holi colour bursting in the sky behind them (art/ColorBlast.js).
 * In preview it uses the same sample date as the first page.
 */
const Closing = ({ eventDate, isPreview }) => {
  const ref = useRef(null);
  useLive(ref);
  const date = isPreview ? new Date(addDaysToDate(16)) : parseAsLocalDate(eventDate);
  return (
    <section ref={ref} className="ut-closing" aria-label="See you at the wedding">
      <ColorBlast className="ut-closing__blast" />
      <Toran className="ut-closing__toran" />
      <Petals className="ut-closing__petals" count={14} seed={97} spread />
      <Reveal className="ut-closing__message">
        <p className="ut-script ut-closing__script">With love &amp; blessings</p>
        <p className="ut-closing__title">Looking forward to celebrating with you!</p>
        <MarigoldDivider />
        <p className="ut-kicker">Save the date</p>
        {date && <p className="ut-kicker ut-closing__date">{moment(date).format("MMMM DD, YYYY")}</p>}
      </Reveal>
      <div className="ut-closing__scene" aria-hidden="true">
        <Reveal effect="rise" threshold={0.1}>
          <img className="ut-closing__scene-img" src={folkFestival} alt="" draggable="false" loading="lazy" decoding="async" />
        </Reveal>
      </div>
    </section>
  );
};

const mapStateToProps = (state) => ({
  eventDate: state.inviteDetails.invite?.eventDate,
  isPreview: state.inviteDetails?.isPreview,
});

export default connect(mapStateToProps)(Closing);
